import React from 'react'
import { FastField, useField } from 'formik'
import { Box, Typography, Grid } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { Info } from '@mui/icons-material'
import { CustomCheckbox } from 'src/form'
import { CustomTooltip } from 'src/designSystem'

const useStyles = makeStyles((theme) => ({
  exclusionIcon: {
    color: theme.palette.info.main,
  },
}))

const ExclusionWarning = () => {
  const styles = useStyles()
  return (
    <CustomTooltip title="Risk of exclusion" placement="left">
      <Info titleAccess="Risk of exclusion" classes={{ root: styles.exclusionIcon }} />
    </CustomTooltip>
  )
}

type GridItem = {
  name: string
  label: string
}

export type Props = {
  title: string
  items: GridItem[]
  exclusionCriteria: Set<string>
}

type ExclusionCriteriaItemProps = {
  item: GridItem
  isExclusionCriterion: boolean
}

const ExclusionCriteriaItem = ({ item, isExclusionCriterion }: ExclusionCriteriaItemProps) => {
  const [field] = useField<boolean>(item.name)
  const isSelected = field.value

  return (
    <Grid item xs={4}>
      <Box display="flex" justifyContent="space-between" alignItems="center" pr={6}>
        <FastField component={CustomCheckbox} name={item.name} label={item.label} condensed />
        {isExclusionCriterion && isSelected && <ExclusionWarning />}
      </Box>
    </Grid>
  )
}

const SECTION_ITEM_MARGIN_TOP = 3

const ExclusionCriteriaFields = (props: Props) => {
  const { title, items, exclusionCriteria } = props
  return (
    <Box mt={SECTION_ITEM_MARGIN_TOP} mx={0}>
      <Typography variant="h4">{title}</Typography>
      <Grid container>
        {items.map((item) => (
          <ExclusionCriteriaItem key={item.name} item={item} isExclusionCriterion={exclusionCriteria.has(item.name)} />
        ))}
      </Grid>
    </Box>
  )
}

export default ExclusionCriteriaFields
